<template>
  <section>
    <div class="row mb-4">
      <button :class="['btn', 'btn-secondary', { 'active': 'phone' == cl }]" @click="setRT('phone')">
        <i class="fas fa-phone icon"></i>
      </button>

      <button :class="['btn', 'btn-secondary', { 'active': 'tables' == cl }]" @click="setRT('tables')">
        <i class="fas fa-table icon"></i>
      </button>

      <button :class="['btn', 'btn-secondary', { 'active': 'toggle' == cl }]" @click="setRT('toggle')">
        <i class="fas fa-reply icon"></i>
      </button>
    </div>

    <div class="row" v-show="toggleRealtime">
      <realtime-phone :class="[{ 'toggle-el': !toggleRealtime }]" />
    </div>

    <div class="row" v-show="!toggleRealtime">
      <RtmCallDetailsTable :conSocket="connection"></RtmCallDetailsTable>
      <RtmUsersDetailsTable :conSocket="connection"></RtmUsersDetailsTable>
      <br>
      <div class="col-md-12 tab-one-wrapper">
        <div class="card-status-center">
            <Group :queues="queues" @selection-changed="updateChartFilter" />
        </div>
      </div>
      <ServiceLevelRealtime :filter="chartFilter"></ServiceLevelRealtime>
    </div>
  </section>
    
</template>

<script>
import RealtimePhone from "./RealtimePhone.vue";
import RtmCallDetailsTable from "./components/RealtimeCallDetailsTable.vue";
import RtmUsersDetailsTable from "./components/RealtimeUsersDetailsTable.vue";
import ServiceLevelRealtime from "../charts/ServiceLevelRealtime.vue";
import Group from '../filters/Group.vue';
const parsedTelefone = (process.env.MIX_TELEFONE === 'true');
const rtmPort = process.env.APP_PORT || 3007;
const conSocket = parsedTelefone ? io.connect(`${location.protocol}//${location.hostname}:${rtmPort}/realtimeModule`) : { on: () => { }, emit: () => { } };

export default {
  name: "RealtimeApp",
  components: {
    RealtimePhone,
    RtmCallDetailsTable,
    RtmUsersDetailsTable,
    ServiceLevelRealtime,
    Group
  },
  data() {
    return {
      toggleRealtime: true,
      intervalId: "",
      cl: "phone",
      chartFilter: "*",
      connection: {
        on: () => { },
        emit: () => { }
      }
    };
  },
  created() {
    this.connection = conSocket;
    if (this.cl == "toggle") {
      this.intervalId = setInterval(() => {
        this.toggleRealtime = !this.toggleRealtime;
      }, 15000);
    }
    this.fetchQueuesAndGroups();
  },
  methods: {
    setRT(style) {
      this.cl = style;
      clearInterval(this.intervalId);

      if (style == "phone") {
        return (this.toggleRealtime = true);
      }

      if (style == "tables") {
        return (this.toggleRealtime = false);
      }

      if (style == "toggle") {
        this.intervalId = setInterval(() => {
          this.toggleRealtime = !this.toggleRealtime;
        }, 15000);
      }
    },

    fetchQueuesAndGroups() {
        axios.get('/user/listQueueUser').then(({ data }) => {
          this.queues = data;
        });
      },
      updateChartFilter(newFilter) {
        this.chartFilter = newFilter;
      }
  },
};
</script>

<style scoped>
.toggle-el {
  display: none;
}

.container-align {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

.card-status-center{
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 10px;
}
</style>